<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-2">
          Batch Approve Paid Payments
        </p>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="3">
            <p class="caption">Total:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="9">
            <p class="caption font-weight-bold">
              {{ formatCurrency(total) }}
            </p>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <!-- <transition name="fade" mode="out-in"> -->
        <div v-if="step == 1" key="1">
          <v-row>
            <v-col class="py-2" cols="12" sm="12" md="12">
              <p>Are you sure you would like to approve the paid payments?</p>
            </v-col>
          </v-row>

          <v-expansion-panels class="pb-2 my-2" accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header class="py-2 body-2"
                >Payments
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-divider class="mb-0"></v-divider>

                <v-list-item
                  v-for="payment in payments"
                  :key="`payment_approve_${payment.paidPaymentId}`"
                  three-line
                >
                  <v-list-item-avatar color="grey">
                    <p class="caption white--text">{{ payment.refNo }}</p>
                    <!-- <v-icon class="grey lighten-1" dark> mdi-cash </v-icon> -->
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="body-2">
                      Total amount:
                      {{ formatCurrency(payment.total) }}</v-list-item-title
                    >
                    <v-list-item-subtitle class="caption">
                      Category:
                      {{ payment.category }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-if="payment.amountPaid"
                      class="caption"
                    >
                      Description:
                      {{ payment.description }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else class="caption grey--text">
                      No description provided
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mb-1"></v-divider>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row>
            <v-col class="py-2" cols="12" sm="12" md="12">
              <v-checkbox v-model="confirmSendEmail" class="my-0" hide-details>
                <template v-slot:label> Send email to tenant </template>
              </v-checkbox>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="font-weight-bold"
              color="primary"
              text
              @click="finish()"
              >Yes</v-btn
            >
            <v-btn
              class="font-weight-bold"
              color="grey darken-1"
              text
              @click="cancel"
              >No</v-btn
            >
          </v-card-actions>
        </div>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { formatCurrency } from '../../util/currency'
export default {
  data() {
    return {
      formatCurrency,
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      loading: true,
      payments: [],
      total: 0,
      step: 1,
      confirmSendEmail: false
    }
  },
  methods: {
    async open({ payments }) {
      this.loading = true
      this.dialog = true
      this.payments = payments
      this.total = payments.reduce(
        (total, paymentRequest) => total + paymentRequest.total,
        0
      )
      this.step = 1
      this.confirmSendEmail = false

      this.loading = false
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      this.loading = true
      if (
        await this.$store.dispatch('payments/batchApprovePaidPayments', {
          payments: this.payments,
          confirmSendEmail: this.confirmSendEmail
        })
      ) {
        this.$root
          .$confirm({
            title: 'Approve Batch Paid Payments',
            message: `The payments have been approved.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
            this.dialog = false
            this.resolve(this.payments)
          })
      } else {
        this.$root
          .$confirm({
            title: 'Approve Batch Paid Payments',
            message: `There was an error processing your request.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
          })
      }
    },
    cancel() {
      this.dialog = false
      this.loading = false
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.v-expansion-panel {
  border-style: solid;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.12);
}
</style>
